import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Card, Typography } from '@mui/material';

ChartJS.register(ArcElement, Tooltip, Legend);

const ProjectChart = ({ data }) => {
  const total = data.reduce((acc, item) => acc + item.count, 0);

  const chartData = {
    labels: data.map((item) => item.status_name),
    datasets: [
      {
        data: data.map((item) => item.count),
        backgroundColor: [
          'rgba(246, 141, 43, 1)',
          'rgba(52, 75, 253, 1)',
          'rgba(73, 166, 119, 1)',
          'rgba(250, 137, 139, 1)',
        ], // Define consistent colors
        hoverOffset: 4,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            const count = tooltipItem.raw;
            const percentage = ((count / total) * 100).toFixed(1);
            return `${tooltipItem.label}: ${count}  (${percentage}%)`;
          },
        },
      },
      legend: {
        display: false, // Hide the default legend
      },
    },
    cutout: '70%', // Makes room for the center text
  };

  return (
    <Card
      style={{
        padding: '16px',
        boxShadow: 'unset !important',
      }}
    >
      {/* <Typography variant="h6" style={{ marginBottom: "16px" }}>
        Project
      </Typography> */}
      <div className='row align-items-center'>
        {/* Chart Section */}
        {/* style={{ display: "flex", justifyContent: "center" }} */}
        <div className='col-md-6'>
          <div style={{ position: 'relative' }}>
            <Doughnut data={chartData} options={options} />
            <div
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                textAlign: 'center',
              }}
            >
              <Typography variant='h4' className='text-dark'>
                {total}
              </Typography>
            </div>
          </div>
        </div>
        {/* Legend Section */}
        <div
          className='col-md-6'
          style={{
            // marginTop: "16px",
            display: 'flex',
            // flexDirection: "column",
            justifyContent: 'center',

            gap: '8px',
          }}
        >
          <div>
            {data.map((item, index) => (
              <div
                key={item.status_name}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '8px',
                  // justifyContent: "center",
                }}
              >
                <div
                  style={{
                    width: '16px',
                    height: '16px',
                    backgroundColor:
                      chartData.datasets[0].backgroundColor[index],
                    borderRadius: '50%',
                    marginRight: '8px',
                  }}
                ></div>
                <Typography className='text-dark'>
                  {item.status_name}
                </Typography>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Card>
  );
};

export default ProjectChart;
